<!--TODO FE: Extract common functionalities and make the code DRY-->
<script>
    // Import axios for API consuming in a clean interface.
    import axios from 'axios';

    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    // Import widgets
    import WidgetDate from '../widgets/Date.vue';

    // Import filters
    import FilterReference from '../filters/Reference.vue';
    import FilterClientName from '../filters/ClientName.vue';
    import FilterClientId from '../filters/ClientId.vue';
    import FilterCreditorName from '../filters/CreditorName.vue';
    import FilterCreditorId from '../filters/CreditorId.vue';

    // Import widgets
    import WidgetTable from '../widgets/Table.vue';

    export default {
        mixins: [mixin],
        components: {
            WidgetDate,
            FilterReference,
            FilterClientName,
            FilterClientId,
            FilterCreditorName,
            FilterCreditorId,
            WidgetTable,
        },
        data() {
            return {
                api: this.$store.getters.getText('dashboardApiEndpointDeductions'),
                loading: false,
                lazyLoading: false,
                data: null,
                dossiers: [],
                filters: [],
                resetCount: 0,
                filterCount: 0,
                offset: 0,
                limit: 100,
                orderItems: [{
                    Key: 'ingangsdatum',
                    Direction: 'desc',
                }],
                columns: [
                    {
                        label: this.$store.getters.getText('dashboardFilterReference'),
                        field: 'referentie_nr',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableDossierid'),
                        field: 'dossier_nr',
                        type: 'link',
                        url: this.$store.getters.getText('dashboardUrlDossierdetail'),
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableClient'),
                        field: 'debiteur_naam',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableStartdate'),
                        field: 'ingangsdatum',
                        type: 'date',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTablePhase'),
                        field: 'fase_label',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableStatusdate'),
                        field: 'status_datum',
                        type: 'date',
                    },
                    {
                        label: this.$store.getters.getText('dashboardWidgetSumsHeadsum'),
                        field: 'hoofdsom',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableTocollectbyyou'),
                        field: 'voor_opdrachtgever_te_incasseren',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableTobepaid'),
                        field: 'vordering_debiteur_openstaand_inc_btw',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableDeductionfirstterm'),
                        field: 'datum_eerste_termijn',
                        type: 'date',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableDeductionamount'),
                        field: 'termijn_bedrag',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableDeductionperiod'),
                        field: 'termijn_periode',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableDeductionagreedterms'),
                        field: 'aantal_afgesproken_termijnen',
                        type: 'nullableNumber',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableTotalpaidafterhandover'),
                        field: 'betaald_totaal_na_indiening',
                        type: 'currency',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableDeductionlastpayment'),
                        field: 'datum_laatste_betaling',
                        type: 'date',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableDeductionlastterm'),
                        field: 'datum_laatste_termijn',
                        type: 'date',
                    },
                    {
                        label: this.$store.getters.getText('dashboardFilterClientname'),
                        field: 'opdrachtgever_naam',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableClientid'),
                        field: 'opdrachtgever_portal_relatie_nr',
                    },
                    {
                        label: this.$store.getters.getText('dashboardFilterCreditorname'),
                        field: 'eiser_naam',
                    },
                    {
                        label: this.$store.getters.getText('dashboardTableCreditorid'),
                        field: 'eiser_portal_relatie_nr',
                    },
                ],
            }
        },
        computed: {
            computedDossiers() {
                return this.dossiers;
            },
            filterItems() {
                const filterItems = [];
                if (this.filters.length) {
                    this.filters.forEach(filter => {
                        if (!filter || !filter.type) return;
                        const filterItem = this.transformFilterItem(filter);
                        if (!filterItem) return;
                        filterItems.push(filterItem);
                    });
                }
                return filterItems;
            }
        },
        async created() {
            this.loading = true;
            await this.fetchData();
            this.loading = false;
        },
        methods: {
            async onFilter(payload, fetch = true) {
                if (!payload) return;
                this.filters = this.filters.filter(filter => filter.type !== payload.type);
                if (typeof payload.value === 'number' || typeof payload.value === 'string') {
                    if (payload.value) this.filters.push(payload);
                }
                else {
                    if (payload.value.length) this.filters.push(payload);
                }
                if (fetch) {
                    await this.fetchData();
                    if (payload.type != 'reference') this.filterCount++;
                }
            },
            async resetFilters() {
                this.filters = [];
                await this.fetchData();
                this.resetCount++;
            },
            async onLoadLazy(metadata) {
                this.offset = metadata.first;
                this.limit = metadata.last - metadata.first;
                if (!this.offset) {
                    await this.fetchData();
                }
                else {
                    await this.fetchData(false);
                }
            },
            async fetchData(isNew = true, loadAll = false) {
                try {
                    this.lazyLoading = true;
                    const response = await axios.post(
                        this.api,
                        {
                            Limit: this.limit,
                            Offset: this.offset,
                            Text: '',
                            FilterItems: this.filterItems,
                            OrderItems: this.orderItems,
                        }
                    );
                    if (!response || response.status != 200 || !response.data) throw 'no response or bad status';
                    if (isNew) {
                        this.data = response.data;
                        this.dossiers = Array.from({ length: this.data.queryCount }).map(x => {
                            return {};
                        });
                    }

                    response.data.items.forEach((item, index) => {
                        if (!this.dossiers[index + this.offset].dossier_nr) this.dossiers[index + this.offset] = { ...item, dossier_nr: this.parseDossierNr(item.dossier_nr) };
                    })

                    if (loadAll && response.data.queryCount > this.limit) {
                        const totalCount = response.data.queryCount;
                        const numChunks = Math.ceil((totalCount - this.limit) / this.limit);
                        if (numChunks > 0) {
                            const chunkPromises = [];
                            for (let i = 1; i <= numChunks; i++) {
                                chunkPromises.push(
                                    axios.post(
                                        this.api,
                                        {
                                            Limit: this.limit,
                                            Offset: i * this.limit,
                                            Text: '',
                                            FilterItems: this.filterItems,
                                            OrderItems: this.orderItems,
                                        }
                                    )
                                );
                            }
                            const chunkResults = await Promise.all(chunkPromises);
                            let offset = this.limit;
                            for (const newResponse of chunkResults) {
                                if (!newResponse || newResponse.status !== 200 || !newResponse.data) throw new Error('No response or bad status');
                                newResponse.data.items.forEach((item, index) => {
                                    if (!this.dossiers[index + offset].dossier_nr) this.dossiers[index + offset] = { ...item, dossier_nr: this.parseDossierNr(item.dossier_nr) };
                                });
                                offset += this.limit;
                            }
                        }
                    }

                    this.lazyLoading = false;
                } catch (error) {
                    console.error('Error loading JSON data: ', error);
                }
            },
            onSort(sortObj) {
                if (sortObj && sortObj.field) {
                    this.orderItems = [{
                        Key: sortObj.field,
                        Direction: sortObj.order === 1 ? 'asc' : 'desc',
                    }];
                    this.fetchData();
                }
            },
            async onLoadAll(resolve) {
                this.offset = 0;
                this.limit = 10000;
                await this.fetchData(false, true);
                resolve();
            },
        }
    };
</script>

<template>
    <div v-if="loading" class="has-text-centered">
        <div class="lds-facebook has-text-grey-lighter">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div v-else :key="`deductions-${resetCount}`" class="tile is-ancestor is-vertical">
        <div class="tile is-child">
            <div class="is-flex is-justify-content-space-between">
                <div class="has-background-white">
                    <button v-if="filterItems.length" @click="resetFilters" class="button is-danger is-outlined">
                        <span>{{ $store.getters.getText('dashboardLabelRemovefilters') }}</span>
                        <span class="icon"><i class="fa-solid fa-times"></i></span>
                    </button>
                </div>
                <div class="has-background-white">
                    <button @click="$store.commit('toggleHighContrast');" :class="['button', 'is-primary', $store.getters.getHighContrast ? '' : 'is-outlined']">
                        <span class="mr-1">{{ $store.getters.getText('dashboardLabelHighcontrast') }}:</span>
                        <span v-if="$store.getters.getHighContrast">{{ $store.getters.getText('dashboardLabelOn') }}</span>
                        <span v-else>{{ $store.getters.getText('dashboardLabelOff') }}</span>
                        <span class="icon"><i class="fa-solid fa-palette"></i></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="tile is-parent">
            <div class="tile is-child is-3">
                <widget-date />
            </div>
            <div class="tile is-child is-9">
                <div :class="['box', 'is-shadowless', $store.getters.getHighContrast ? 'has-background-white' : 'has-background-tertiary', 'dashboard-title']">
                    <h2 :class="['title', 'is-6', $store.getters.getHighContrast ? 'has-text-quaternary' : 'has-text-white']">{{ $store.getters.getText('dashboardTitleDeductions') }}</h2>
                </div>
            </div>
        </div>
        <div v-if="dossiers.length" class="tile is-parent">
            <div class="tile is-child">
                <filter-reference :key="`filter-${filterCount}`" :api="api" :filter-items="filterItems" @filter="(payload) => onFilter(payload)" />
            </div>
            <div class="tile is-child">
                <filter-client-name :data="data" @filter="(payload) => onFilter(payload)" />
            </div>
            <div class="tile is-child">
                <filter-client-id :data="data" @filter="(payload) => onFilter(payload)" />
            </div>
            <div class="tile is-child">
                <filter-creditor-name :data="data" @filter="(payload) => onFilter(payload)" />
            </div>
            <div class="tile is-child">
                <filter-creditor-id :data="data" @filter="(payload) => onFilter(payload)" />
            </div>
        </div>
        <div v-if="dossiers.length" class="tile is-parent">
            <div class="tile is-child is-scrollable">
                <widget-table :lazy-loading="lazyLoading" :dossiers="computedDossiers" :columns="columns" sortfield="ingangsdatum" export-filename="Lopende_inhoudingen1" @load-lazy="(payload) => onLoadLazy(payload)" @sort="(payload) => onSort(payload)" @load-all="onLoadAll" />
            </div>
        </div>
        <div v-else>
            <p class="pt-4 has-text-centered">{{ $store.getters.getText('dashboardLabelNoresultsfound') }}</p>
        </div>
    </div>
</template>
